import Log from '@/classes/debug/Log'
import auditorApi from '@/api/auditor/auditorApi'
import caseApi from '@/api/case/caseApi'
import AuthUser from '@/classes/auth/AuthUser'
import { Auditor, AuditorRequest } from '@/classes/case/Auditor'
import { Case } from '@/classes/case/Case'
import { getFilter } from '@/store/utility_functions'

const DEFAULT_SORT = 'case_id'

const state = {
  auditors: [],
  auditorRequests: [],
  auditorOngoingCases: [],
  lateCustomerCases: [],
  customerRespondedCases: [],
  currentAuditor: null
}

const mutations = {
  setStateAuditors: (state, data) => {
    state.auditors = Auditor.asAuditors(data)
  },
  setStateCaseRequests: (state, data) => {
    state.auditorRequests = AuditorRequest.asAuditorRequests(data)
  },
  setAuditorOngoingCases: (state, data) => {
    state.auditorOngoingCases = Case.asCases(data)
  },
  setLateCustomerCases: (state, data) => {
    state.lateCustomerCases = Case.asCases(data)
  },
  setCustomerRespondedCases: (state, data) => {
    state.customerRespondedCases = Case.asCases(data)
  },
  setStateCurrentAuditor: (state, data) => {
    state.currentAuditor = Auditor.asAuditor(data)
  }
}

const actions = {
  getAuditors ({ commit }) {
    return auditorApi.getAuditors().then((response) => {
      commit('setStateAuditors', response.data)
      return true
    }).catch((err) => {
      throw err
    })
  },
  getAuditorRequestsForCase ({ commit }, postData) {
    let filter = `?case=${postData.caseId}`
    return caseApi.getAuditorRequests(postData.auditorId, filter).then((response) => {
      commit('setStateCaseRequests', response.data.results)
      return true
    }).catch((err) => {
      throw err
    })
  },
  getAuditorOngoingCases ({ commit }, request) {
    request.ordering = request.ordering || DEFAULT_SORT
    let params = Object.assign({}, request, { auditorId: null })
    let filter = getFilter(params)
    return caseApi.getAuditorCases(request.auditorId, filter).then((response) => {
      commit('setAuditorOngoingCases', response.data.results)
      return response.data
    }).catch((err) => {
      throw err
    })
  },
  getLateCustomerCases ({ commit }, request) {
    request.ordering = request.ordering || DEFAULT_SORT
    let params = Object.assign({}, request, { auditorId: null })
    let filter = getFilter(params)
    return caseApi.getAuditorCases(request.auditorId, filter).then((response) => {
      commit('setLateCustomerCases', response.data.results)
      return response.data
    }).catch((err) => {
      throw err
    })
  },
  getCustomerRespondedCases ({ commit }, request) {
    request.ordering = request.ordering || DEFAULT_SORT
    let params = Object.assign({}, request, { auditorId: null })
    let filter = getFilter(params)
    return caseApi.getCustomerRespondedCases(request.auditorId, filter).then((response) => {
      commit('setCustomerRespondedCases', response.data.results)
      return response.data
    }).catch((err) => {
      throw err
    })
  },
  getPendingAuditorRequests ({ commit }, auditorId) {
    let filter = `?state=${AuditorRequest.PENDING}`
    return caseApi.getAuditorRequests(auditorId, filter).then((response) => {
      commit('setStateCaseRequests', response.data.results)
      return true
    }).catch((err) => {
      throw err
    })
  },
  saveAuditorRequest ({ commit }, postData) {
    return caseApi.postAuditorRequest(postData.caseId, postData.auditorId).then((response) => {
      Log.debug('Request sent to auditor as ' + AuthUser.getProfileTypeVerbose())
      return response
    }).catch((err) => {
      throw err
    })
  },
  updateAuditorRequest ({ commit }, data) {
    return caseApi.patchAuditorRequest(data.postData.requestId, data.postData.state).then((response) => {
      commit('updateStateCases', {
        current: data.caseData,
        updated: Case.asCase(response.data)
      })
      return true
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
